import { LimitRedistributionSchema } from "./LimitRedistributionSchema";
import { DTDetailTableSchema } from "./DTDetailTableSchema";
import { LimitDetailTableSchema } from "./LimitDetailSchema";
import { CarAdminLimitDetailSchema } from "./CarAdminLimitDetailSchema";
import { GuarantorTableSchema } from "./GuarantorTableSchema";
import { HouseOwnerSchema, ApplicationCustomerAsHouseOwnerSchema, } from "./HouseOwnerSchema";
import { ApplicationCustomersSchema } from "./ApplicationCustomersSchema";
import { PropertiesSchema } from "./PropertiesSchema";
import { LienSchema } from "./LiensSchema";
import { ApplicationDebtSchema, LimitedApplicationDebtSchema, LimitedRefinancedApplicationDebtSchema, } from "./ApplicationDebtSchema";
export const tableSchemas = {
    ApplicationCustomersSchema: new ApplicationCustomersSchema(),
    ApplicationCustomerAsHouseOwner: new ApplicationCustomerAsHouseOwnerSchema(),
    ApplicationDebtSchema: new ApplicationDebtSchema(),
    CarAdminLimitDetailSchema: new CarAdminLimitDetailSchema(),
    DTTableSchema: new DTDetailTableSchema(),
    GuarantorSchema: new GuarantorTableSchema(),
    HouseOwnerSchema: new HouseOwnerSchema(),
    LiensSchema: new LienSchema(),
    LimitDetailSchema: new LimitDetailTableSchema(),
    LimitRedistributionSchema: new LimitRedistributionSchema(),
    LimitedApplicationDebtSchema: new LimitedApplicationDebtSchema(),
    LimitedRefinancedApplicationDebtSchema: new LimitedRefinancedApplicationDebtSchema(),
    PropertiesSchema: new PropertiesSchema()
};
//# sourceMappingURL=TableSchemas.js.map